import { render, staticRenderFns } from "./AppUserForm.vue?vue&type=template&id=3961769c&"
import script from "./AppUserForm.vue?vue&type=script&lang=js&"
export * from "./AppUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3961769c')) {
      api.createRecord('3961769c', component.options)
    } else {
      api.reload('3961769c', component.options)
    }
    module.hot.accept("./AppUserForm.vue?vue&type=template&id=3961769c&", function () {
      api.rerender('3961769c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/basic/whitelist/modules/AppUserForm.vue"
export default component.exports